import { Header } from '@/components/Header';
import { TopBar } from '@/components/TopBar';
import { Footer } from '@/components/Footer';

export default function Imprint() {
  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header />
      
      <main className="pt-24 pb-20">
        <div className="container-0g">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">Imprint / Legal Notice</h1>
            <p className="text-slate-500 mb-8">Company Information</p>
            
            <div className="prose prose-slate max-w-none">
              <p className="text-lg text-slate-600 mb-8">
                Information pursuant to legal requirements for business identification and transparency.
              </p>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">Company Details</h2>
                
                <div className="grid md:grid-cols-3 gap-6">
                  <div className="bg-slate-50 p-6 rounded-sm border border-slate-200">
                    <h3 className="text-lg font-semibold text-slate-900 mb-3">Lithuania</h3>
                    <p className="text-slate-600 mb-2"><strong>0g Baltics UAB</strong></p>
                    <p className="text-slate-600 text-sm">
                      A. Goštauto g. 8-358<br/>
                      LT-01108 Vilnius<br/>
                      Lithuania
                    </p>
                    <p className="text-slate-600 text-sm mt-3">
                      <strong>Registration:</strong> Lithuanian Register of Legal Entities
                    </p>
                  </div>

                  <div className="bg-slate-50 p-6 rounded-sm border border-slate-200">
                    <h3 className="text-lg font-semibold text-slate-900 mb-3">Latvia</h3>
                    <p className="text-slate-600 mb-2"><strong>0g Baltics SIA</strong></p>
                    <p className="text-slate-600 text-sm">
                      Elizabetes iela 31-8<br/>
                      LV-1010 Riga<br/>
                      Latvia
                    </p>
                    <p className="text-slate-600 text-sm mt-3">
                      <strong>Registration:</strong> Latvian Enterprise Register
                    </p>
                  </div>

                  <div className="bg-slate-50 p-6 rounded-sm border border-slate-200">
                    <h3 className="text-lg font-semibold text-slate-900 mb-3">Estonia</h3>
                    <p className="text-slate-600 mb-2"><strong>E2 Technologies OÜ</strong></p>
                    <p className="text-slate-600 text-sm">
                      Lõõtsa tn 5<br/>
                      11415 Tallinn<br/>
                      Estonia
                    </p>
                    <p className="text-slate-600 text-sm mt-3">
                      <strong>Registration:</strong> Estonian Commercial Register
                    </p>
                  </div>
                </div>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">Contact Information</h2>
                <div className="bg-slate-50 p-6 rounded-sm border border-slate-200">
                  <p className="text-slate-600 mb-2"><strong>Email:</strong> <a href="mailto:info@0gbaltics.com" className="text-teal-600 hover:underline">info@0gbaltics.com</a></p>
                  <p className="text-slate-600"><strong>Website:</strong> <a href="https://0gbaltics.com" className="text-teal-600 hover:underline">www.0gbaltics.com</a></p>
                </div>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">Management</h2>
                <p className="text-slate-600">
                  The companies are managed by their respective directors as registered with the relevant national commercial registers.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">Business Activities</h2>
                <p className="text-slate-600">
                  0g Baltics provides IoT (Internet of Things) infrastructure solutions including:
                </p>
                <ul className="list-disc pl-6 text-slate-600 space-y-2 mt-4">
                  <li>Smart Lockers</li>
                  <li>Smart Metering</li>
                  <li>Asset Tracking (Indoor/Outdoor)</li>
                  <li>Elderly Care Solutions</li>
                  <li>Indoor Air Quality Monitoring</li>
                  <li>Energy Monitoring</li>
                  <li>Office Space Management</li>
                  <li>IoT Infrastructure Consulting</li>
                </ul>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">Liability Disclaimer</h2>
                <p className="text-slate-600 mb-4">
                  <strong>Content:</strong> The content of this website has been prepared with care. However, we cannot guarantee the accuracy, completeness, or timeliness of the information provided. We reserve the right to modify or delete content without prior notice.
                </p>
                <p className="text-slate-600">
                  <strong>External Links:</strong> This website may contain links to external websites. We have no control over the content of these websites and therefore cannot assume any liability for their content. The respective provider or operator of the linked pages is always responsible for their content.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">Copyright</h2>
                <p className="text-slate-600">
                  The content and works published on this website are subject to copyright law. Any reproduction, editing, distribution, or any kind of use outside the limits of copyright law requires the prior written consent of the respective author or creator.
                </p>
              </section>

              <section className="mb-10">
                <h2 className="text-2xl font-semibold text-slate-900 mb-4">Dispute Resolution</h2>
                <p className="text-slate-600">
                  The European Commission provides a platform for online dispute resolution (ODR): <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:underline">https://ec.europa.eu/consumers/odr</a>
                </p>
                <p className="text-slate-600 mt-4">
                  We are not obliged and not willing to participate in dispute resolution proceedings before a consumer arbitration board.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
